const lsBkPoints = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
};
export const UCarrouselConfig = {
    type: "carousel",
    perView: 1,
    focusAt: "center",
    peek: 100,
    gap: 28,
    breakpoints: {
        [lsBkPoints.sm]: {
            perView: 1,
            peek: 0,
            gap: 0
        },
        [lsBkPoints.md]: { perView: 1 },
        [lsBkPoints.lg]: { perView: 1 },
    },
};
export const USocialSlider = {
    type: "slider",
    perView: 2,
    peek: {
        before: 0,
        after: 400
    },
    breakpoints: {
        [lsBkPoints.sm]: {
            perView: 1,
            peek: {
                before: 0,
                after: 120
            },
        },
        [lsBkPoints.xl]: {
            peek: {
                before: 0,
                after: 200
            },
        },
    },
};
// Carling page config
export const UCarlingCarrouselConfig = {
    type: "carousel",
    perView: 4,
    focusAt: "center",
    peek: {
        before: 0,
        after: 10
    },
    gap: 30,
    breakpoints: {
        [lsBkPoints.sm]: {
            perView: 1,
            peek: 80,
            gap: 17
        },
        [lsBkPoints.lg]: {
            perView: 3,
            peek: 0,
            gap: 17
        },
    },
};
export const URematchCarrouselConfig = {
    type: "slider",
    perView: 2,
    peek: {
        before: 0,
        after: 400
    },
    breakpoints: {
        [lsBkPoints.lg]: {
            perView: 1,
            peek: {
                before: 0,
                after: 120
            },
        },
        [lsBkPoints.xl]: {
            perView: 1,
            peek: {
                before: 0,
                after: 40
            },
        },
    },
};
// No excuse Carrousel Config
export const UNoExcuseCarrouselConfig = {
    type: "carousel",
    perView: 1,
};
// History carrousel 
export const UHistoryCarrouselConfig = {
    type: "carousel",
    perView: 1,
};
